import axios from 'axios'
import constants from '../../config'
import Form from '../../plugins/Form';
import {dash} from '../../utils/componentHelper';

let emptyForm = new Form({})

const state = {
  profileData: null,

  storeChangePasswordStatus: null,
  storeChangePasswordErrors: emptyForm.errors,

  storePayoutInformationStatus: null,
  storePayoutInformationErrors: emptyForm.errors,

  storePersonalInformationStatus: null,
  storePersonalInformationErrors: emptyForm.errors,

  storePaymentInformationStatus: null,
  storePaymentInformationErrors: emptyForm.errors,

  storeContactInformationStatus: null,
  storeContactInformationErrors: emptyForm.errors,
}

// getters
const getters = {
  profileData: (state) => {
    return state.profileData
  },

  storeInformationStatus: (state) => (informationType) => {
    return state[`store${informationType}Status`]
  },

  storeInformationErrors: (state) => (informationType) => {
    return state[`store${informationType}Errors`]
  }
}

// actions
const actions = {

  fetchData ({commit}) {
    return axios.get(constants.BASE_URL + 'profile/data')
     .then(function (resp) {
       commit('setProfileData', resp.data)
     })
     .catch(function (resp) {
       console.log('Profile data could not be found', resp)
     })
  },

  storeInformation({commit, state}, formData) {
    let form = new Form(formData)
    let endpoint = `profile/${dash(formData.informationType)}`
    let requestType = 'put'

    return form.submit(requestType, constants.BASE_URL + endpoint)
      .then((resp) => {
        commit('setStoreInformationStatus', {'status': 'success', 'informationType': formData.informationType})
        commit('setStoreInformationErrors', {'errors': form.errors, 'informationType': formData.informationType})
      })
      .catch((resp) => {
        commit('setStoreInformationStatus', {'status': 'failed', 'informationType': formData.informationType})

        if (form.errors.any()) {
          commit('setStoreInformationErrors', {'errors': form.errors, 'informationType': formData.informationType})
        } else {
          let internalError = {internalError: true}

          form.errors.record(internalError)
          commit('setStoreInformationErrors', {'errors': form.errors, 'informationType': formData.informationType})
        }
      })
  },
}


// mutations
const mutations = {
  setProfileData (state, data) {
    state.profileData = data
  },

  setStoreInformationStatus (state, data) {
    state[`store${data.informationType}Status`] = data.status
  },

  setStoreInformationErrors (state, data) {
    state[`store${data.informationType}Errors`] = data.errors
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}